import { render, staticRenderFns } from "./CustomerHeader.vue?vue&type=template&id=3f3783a1&scoped=true&"
import script from "./CustomerHeader.vue?vue&type=script&lang=js&"
export * from "./CustomerHeader.vue?vue&type=script&lang=js&"
import style0 from "./CustomerHeader.vue?vue&type=style&index=0&id=3f3783a1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f3783a1",
  null
  
)

export default component.exports